/**
 * 稿子的 `.ring`：68px 的 SVG 进度环。
 *
 * 取代原来那三张等权重统计卡 —— 三个数并列要人自己算「还剩几件」，
 * 环 + 一句「今天还有 7 件事」直接说结论。
 *
 * 渐变描边要一个 <linearGradient>，而 SVG 的 gradient 只能被**同一个文档里**的
 * url(#id) 引用，所以 defs 就放在这个组件里、跟着它一起挂载。id 用固定字符串
 * （一页只有一个环；将来一页两个环时换成 useId）。
 *
 * 转 -90° 是为了让 0% 的起点在正上方；stroke-dasharray/offset 是画弧的标准手法，
 * 过渡挂在 offset 上（挂在 dasharray 上会连线宽一起抖）。
 */
export default function ProgressRing({ done, total }: { done: number; total: number }) {
  const R = 29
  const C = 2 * Math.PI * R
  const pct = total > 0 ? done / total : 0

  return (
    <div className="relative shrink-0">
      <svg viewBox="0 0 68 68" aria-hidden="true" className="w-[68px] h-[68px] -rotate-90">
        <defs>
          <linearGradient id="ringGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="var(--color-brand)" />
            <stop offset="1" stopColor="var(--color-brand2)" />
          </linearGradient>
        </defs>
        <circle cx="34" cy="34" r={R} fill="none" strokeWidth="7" className="stroke-sunk" />
        <circle
          cx="34"
          cy="34"
          r={R}
          fill="none"
          strokeWidth="7"
          strokeLinecap="round"
          stroke="url(#ringGrad)"
          strokeDasharray={C.toFixed(1)}
          strokeDashoffset={(C * (1 - pct)).toFixed(1)}
          className="transition-[stroke-dashoffset] duration-500 ease-sheet"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-[15px] font-extrabold">
        {done}/{total}
      </div>
    </div>
  )
}
